export default __webpack_public_path__ + "static/media/AH-Plus-Jet-StarterKit.45ff1190.png";